import axios, { type AxiosInstance } from "axios";
import Env from "@/core/config/env";
import { applyNetworkInterceptors } from "./interceptors";

interface CreateHttpClientOptions {
  baseURL?: string;
  withCredentials?: boolean;
}

export function createHttpClient({
  baseURL = Env.apiBaseUrl,
  withCredentials = true,
}: CreateHttpClientOptions = {}): AxiosInstance {
  return applyNetworkInterceptors(
    axios.create({
      baseURL,
      headers: {
        Accept: "application/json",
      },
      withCredentials,
    }),
  );
}

export function getServerApiBaseUrl(): string {
  return Env.apiBaseUrl.replace("localhost", "127.0.0.1");
}
